import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, MouseEvent, ReactNode, useCallback } from 'react'

import { cn } from '@/app/utils'
import AppLogoSvg from '@/assets/svg/AppLogo.svg'

type Props = {
  children?: ReactNode
  containerClass?: string
  mainClass?: string
  backLink?: string
  backButtonText?: string
}

export const LayoutSimpleWithHeader: FC<Props> = ({
  children,
  backLink,
  backButtonText,
  containerClass,
  mainClass
}) => {
  const router = useRouter()

  const containerClasses = cn(
    'max-w-[1158px] xl:max-w-[996px] w-full ml-[336px] xl:mx-auto xs:max-w-full md:px-16 md:pr-8',
    containerClass
  )

  const handleBackLinkClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      if (document.referrer) {
        event.preventDefault()
        router.back()
      }
    },
    [router]
  )

  return (
    <>
      <header className="fixed left-0 right-8 z-50 border-b border-b-grey-30 bg-grey-10">
        <div className={cn('pb-16 pt-25', containerClasses)}>
          <Link href="/" title="На главную" className="inline-block">
            <AppLogoSvg className="text-grey-100 transition-colors hover:text-bronze-40" />
          </Link>
        </div>
      </header>

      {backLink && (
        <div className={cn('mt-[112px]', containerClasses)}>
          <Link
            href={backLink}
            className="group flex items-center"
            onClick={handleBackLinkClick}
          >
            <span className="flex h-40 w-40 items-center justify-center rounded-full bg-grey-20 transition-transform group-hover:-translate-x-2">
              <ArrowLeftIcon className="h-20 w-20 text-bronze-70" />
            </span>
            <h1 className="ml-16">{backButtonText || 'Назад'}</h1>
          </Link>
        </div>
      )}

      <main className={cn('pb-32', containerClasses, mainClass)}>
        {children}
      </main>
    </>
  )
}
